import React, { useEffect, useRef } from 'react';

import './HeaderAdUnit.css';

const HEADER_AD_ZONE_DIV_ID = 'header-ad-zone';
const HEADER_AD_FUSE_ID = '23018547786';

export default function HeaderAdUnit() {
  const registeredRef = useRef(false);

  useEffect(() => {
    // Defer so pageInit (useLayoutEffect) runs first on this nav
    const t = setTimeout(() => {
      const f = window.fusetag;
      if (f?.registerZone && !registeredRef.current) {
        f.registerZone(HEADER_AD_ZONE_DIV_ID);
        registeredRef.current = true;
      }
    }, 0);
    return () => clearTimeout(t);
  }, []);

  return <div className="headerAdUnit" id={HEADER_AD_ZONE_DIV_ID} data-fuse={HEADER_AD_FUSE_ID} />;
}